import React from 'react';
// nodejs library that concatenates classes
import classNames from 'classnames';
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
// graphql
import { ApolloClient } from 'apollo-client';
import { ApolloProvider } from 'react-apollo';
import { createHttpLink } from 'apollo-link-http';
import { setContext } from 'apollo-link-context';
import { InMemoryCache } from 'apollo-cache-inmemory';

// @material-ui/icons
// core components
import Header from '../custom-components/Header/Header.jsx';
import Footer from '../components/Footer/Footer.jsx';
import GridContainer from '../components/Grid/GridContainer.jsx';
import GridItem from '../components/Grid/GridItem.jsx';
import HeaderLinks from '../custom-components/Header/HeaderLinks.jsx';
import Parallax from '../components/Parallax/Parallax.jsx';
import profilePageStyle from '../assets/jss/material-kit-react/views/profilePage.jsx';
//file import
import config from '../config';
import history from '../history.js';
import Employmentdetails from './Document/Employment/Employmentdetails.jsx';

import Gravatar from 'react-gravatar';
import date from 'date-and-time';

const httpLink = createHttpLink({
  uri: config.graphqlendpoint.URL
});

const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = localStorage.getItem('accessToken');

  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      Authorization: token ? `Bearer ${token}` : ''
    }
  };
});

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache()
});

class ProfilePage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showgrid: true,
      showemployment: false,
      data: []
    };
  }

  showemployment = empValue => {
    this.setState({
      showgrid: false,
      showemployment: true,
      data: empValue
    });
  };
  render() {
    var expireTime = this.props.location.state.response.data.getFiles.exp_time;
    var expiryTimeInSeconds = new Date(expireTime).getTime() / 1000;
    console.log('expiryTimeInSeconds', expiryTimeInSeconds);
    var currentTime = date.addMinutes(new Date(), 330).toJSON();
    var currentTimeInSeconds = new Date(currentTime).getTime() / 1000;
    console.log('currentTimeInSeconds', currentTimeInSeconds);
    var data = this.props.location.state.response.data;
    var designation = data.showEmployeeDetails.designation;
    var name = data.showEmployeeDetails.name;
    var email = data.showEmployeeDetails.email;
    var profile_image_hash = data.showEmployeeDetails.profile_image_hash;
    var Employment = data.showEmployment;
    var fileContent = this.props.location.state.fileContent;
    const { classes, ...rest } = this.props;
    const imageClasses = classNames(
      classes.imgRaised,
      classes.imgRoundedCircle,
      classes.imgFluid
    );
    if (expiryTimeInSeconds < currentTimeInSeconds) {
      localStorage.clear();
      history.push({
        pathname: '/login'
      });
    }
    // const navImageClasses = classNames(classes.imgRounded, classes.imgGallery);
    return (
      <div>
        <Header
          color='transparent'
          brand='Verify Mate'
          rightLinks={<HeaderLinks />}
          fixed
          changeColorOnScroll={{
            height: 200,
            color: 'white'
          }}
          {...rest}
        />
        <Parallax small filter image={require('../assets/img/bgdark.jpg')} />
        <div className={classNames(classes.main, classes.mainRaised)}>
          <div>
            <div className={classes.container}>
              <GridContainer justify='center'>
                <GridItem xs={12} sm={12} md={6}>
                  <div className={classes.profile}>
                    <div>
                      {/* to display user uploaded image */}
                      {profile_image_hash && fileContent ? (
                        <img
                          src={fileContent}
                          className={imageClasses}
                          alt='...'
                        />
                      ) : (
                        <Gravatar
                          email={email}
                          size={150}
                          default='mp'
                          className={imageClasses}
                        />
                      )}
                    </div>
                    <div className={classes.name}>
                      <h3 className={classes.title}>{name}</h3>
                      <h6>{designation}</h6>
                    </div>
                  </div>
                </GridItem>
              </GridContainer>
              <div className={classes.description}>
                <p>
                  An artist of considerable range, Chet Faker — the name taken
                  by Melbourne-raised, Brooklyn-based Nick Murphy — writes,
                  performs and records all of his own music, giving it a warm,
                  intimate feel with a solid groove structure.{' '}
                </p>
              </div>
              <div>
                {this.state.showgrid ? (
                  <ApolloProvider client={client}>
                    <Employmentdetails
                      key={Employment.username}
                      user={Employment}
                    />
                  </ApolloProvider>
                ) : null}
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default withStyles(profilePageStyle)(ProfilePage);



// WEBPACK FOOTER //
// ./src/Container/ProfilePage.jsx